import { domainKeys } from "./data/domainKeys";

export const ClientPicker = () => {
  const handleLoadRoute = (key) => {
    window.open(domainKeys[key]);
  };
  return (
    <div className="clientPicker">
      <div>
        <p>No leaderboard found...</p>
        <h1>Select a leaderboard to load</h1>
      </div>
      <ul>
        {Object.keys(domainKeys).map((option) => {
          return (
            <li
              onClick={(e) => {
                handleLoadRoute(option);
              }}
            >
              <p>{option}</p>
            </li>
          );
        })}
      </ul>{" "}
    </div>
  );
};
